<template>
    <div class="deviceType">
        <deviceTab @tabClick="tabClick" />
        <v-search
            :formContent="formContent"
            :SearchForm="SearchForm"
            :inline="true"
            :optareBtn="optareBtn"
            @resetFn="resetFn"
            @searchFn="getListFn"
            @confirmFn="getListFn"
            @AddFn="AddFn"
            @delFn="delFns"
        />
        <div class="componentPage">
            <deviceTable :tableData="tableData" :statusParam="statusParam" :loading="loading" @detailFn="detailFn" @delFn="delFn" @choozeTableFn="choozeTableFn" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>

        <!-- 操作弹窗 -->
        <handleDialog
            ref="deviceHandle"
            :deviceWay="deviceWay"
            :isShow.sync="isShow"
            :title="title"
            :handleText="handleText"
            :detailContent="detailContent"
            :statusParam="statusParam"
            :tabsObj="tabsObj"
        />
    </div>
</template>

<script>
import deviceTab from './components/deviceTabs.vue';
import deviceTable from './components/deviceTable.vue';
import handleDialog from './components/handleDialog.vue';

import mixinForm from '@/utils/formMixins.js';
import { deviceTypeList, deviceTypeDetail, deviceTypeDelete } from '@/api/modules/deviceType.js';
import { shareParam } from '@/api/modules/public.js';
export default {
    mixins: [mixinForm],
    components: {
        deviceTab,
        deviceTable,
        handleDialog
    },
    data() {
        return {
            SearchForm: {
                name: '',
                status: ''
            },
            formContent: [
                {
                    id: 1,
                    text: $t('integration.name'),
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true
                },
                {
                    id: 2,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    selectParam: [],
                    isChooze: false
                }
            ],
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.btn_new',
                    method: 'AddFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.tbopt_delete',
                    method: 'delFn'
                }
            ],
            tabsObj: {},
            // 区分模式
            handleText: '',
            // 详情content
            detailContent: {},
            // 选中的table
            choozeTable: [],
            // 状态
            statusParam: [],
            // 设备类型
            deviceWay: 'Sensor'
        };
    },
    created() {
        this.initPatam();
    },
    methods: {
        initPatam() {
            shareParam({ code: 'carrier_type_status', type: 0 }).then(({ result }) => {
                // this.formContent[1].selectParam = result
                let array = [{ value: '', label: 'public.please' }];
                this.statusParam = array.concat(
                    result.map(item => {
                        return {
                            value: item.code,
                            label: 'public.' + item.content
                        };
                    })
                );
                this.formContent[1].selectParam = this.statusParam;
            });
        },
        tabClick(row) {
            this.tabsObj = { ...row };
            this.changeDevice(row.name);
            this.getListFn();
        },
        changeDevice(name) {
            this.deviceWay = name;
        },
        publicFn(title = '', bool) {
            this.isShow = true;
            this.title = title;
            this.$nextTick(() => {
                this.$refs['deviceHandle'].isMode = bool;
                // 清除校验
                this.$refs['deviceHandle'].clearValidate();
            });
        },
        AddFn() {
            this.handleText = 'add';
            this.publicFn($t($t('integration.add')) + `${this.tabsObj.label || $t('public.sensor')}` + $t($t('integration.type')), false);
        },
        detailFn(row) {
            this.publicFn(`${this.tabsObj.label || $t('public.sensor')}` + $t($t('integration.type_details')), true);
            this.handleText = 'detail';
            this.getDetailFn(row.id);
        },
        // 获取详情
        getDetailFn(id) {
            deviceTypeDetail(this.deviceWay.toLowerCase(), id).then(({ result }) => {
                this.detailContent = result;
            });
        },
        choozeTableFn(row) {
            this.choozeTable = row;
        },
        // 删除 单条
        delFn(row) {
            if (row.status === 1) return this.$message.warning($t('integration.enable_status_cannot_be_deleted'));
            this.TODOTIPDEL({ ids: row.id });
        },
        // 删除多条
        delFns() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            const flag = this.choozeTable.some(item => item.status === 1);
            if (flag) return this.$message.warning($t('integration.the_selected_data_has_an_enabled_state_and_cannot_be_deleted'));
            const ids = this.choozeTable.map(item => item.id).join(',');
            this.TODOTIPDEL({ ids });
        },
        TODOTIPDEL(param) {
            this.$confirm($t('integration.deleting_a_device_type_will_delete_all_data_under_that_type_dot__are_you_sure_you_want_to_do_this_q'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    deviceTypeDelete(param, this.deviceWay.toLowerCase()).then(({ state }) => {
                        if (state.code === 200) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        }
                    });
                })
                .catch(() => {});
        },
        resetFn() {
            this.SearchForm = {
                name: '',
                status: '',
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            this.getListFn();
        },

        getListFn() {
            this.loading = true;
            deviceTypeList(this.SearchForm, this.deviceWay.toLowerCase())
                .then(({ result, pageInfo }) => {
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.deviceType {
    padding: 10px 15px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs__header {
        margin: 0;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
